import clsx from 'clsx';
import LoadingSpinner from 'components/common/loading-spinner';

type ColumnLoadingVeilProps = Readonly<{
  showSpinner?: boolean;
  className?: string;
}>;

export default function ColumnLoadingVeil({
  showSpinner = false,
  className
}: ColumnLoadingVeilProps) {
  return (
    <div
      className={clsx(
        'pointer-events-auto absolute inset-0 z-20 flex items-center justify-center bg-gray-200/80',
        className
      )}
      role={showSpinner ? 'status' : undefined}
      aria-label={showSpinner ? 'Loading system' : undefined}
      aria-hidden={showSpinner ? undefined : true}
    >
      {showSpinner ? <LoadingSpinner /> : null}
    </div>
  );
}
